import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  Box
} from '@mui/material';
import { validateXmlUser } from '../../../../utils/validation';
import xmlDealerService from '../../../../services/xmlDealerService';
import { useSelector } from 'react-redux';
import useAlert from '../../../../hooks/useAlert';
const UpdateUserDialog = ({ open, onClose,getXmlUser,selectedUser}) => {
  const { showErrorAlertAll, showSuccessAlertAll } = useAlert();
  const [formErrors, setFormErrors] = useState({});


  const [formData, setFormData] = useState(selectedUser);
  const authUserId = useSelector(state => state?.auth?.user?.id);
  const handleSaveUser = async(newUser) => {
    try{  

      const errors =  validateXmlUser(newUser);
      setFormErrors(errors);
      if (Object.keys(errors).length === 0) {
       await xmlDealerService.updateUser(newUser);
        getXmlUser();
        onClose();
        showSuccessAlertAll();
      }
      }

    catch{showErrorAlertAll();}
  
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
   


    handleSaveUser(formData);
    setFormData({
      name: '',
      surName: '',
      identifier: '',
      phone: '',
      userName: '',
      password: '',
    });
  };
 

  useEffect(()=>{
    setFormData(selectedUser);
  },[selectedUser]);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle sx={{ fontWeight: 'bold' }}>Kullanıcı Düzenle</DialogTitle>
      <DialogContent dividers>
        <Box
          component="form"
          onSubmit={handleSubmit}
          id="add-user-form"
        >
          <Stack spacing={2} sx={{ mt: 1 }}>
            <TextField
              
              label="İsim"
              variant="outlined"
              name="name"
              value={formData?.name}
              onChange={handleChange}
              error={!!formErrors?.name}
              helperText={formErrors?.name}
            />
            <TextField
              
              label="Soyisim"
              variant="outlined"
              name="surName"
              value={formData?.surName}
              onChange={handleChange}
              error={!!formErrors?.surName}
              helperText={formErrors?.surName}
            />
            <TextField
              
              label="TC"
              variant="outlined"
              name="identifier"
              value={formData?.identifier}
              onChange={handleChange}
              error={!!formErrors?.identifier}
              helperText={formErrors?.identifier}
            />
            <TextField
              
              label="Telefon"
              variant="outlined"
              name="phone"
              value={formData?.phone}
              onChange={handleChange}
              error={!!formErrors?.phone}
              helperText={formErrors?.phone}
            />
            <TextField
              
              label="Kullanıcı Adı"
              variant="outlined"
              type="text"
              name="userName"
              value={formData?.userName}
              onChange={handleChange}
              error={!!formErrors?.userName}
              helperText={formErrors?.userName}
            />
            <TextField
              
              label="Şifre"
              variant="outlined"
              type="text"
              name="password"
              value={formData?.password}
              onChange={handleChange}
              error={!!formErrors?.password}
              helperText={formErrors?.password}
            />
          </Stack>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>İptal</Button>
        <Button
        sx={{borderRadius:2}}
          variant="contained"
          color="primary"
          type="submit"
          form="add-user-form"
        >
          Kaydet
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateUserDialog;
